import { Form, Select } from "antd";
import React, { useEffect, useState } from "react";
import qs from "qs";
import { FormItemProps } from "antd/lib/form";
import UIFetchService from "../../../Service/UIFetchService";

type Props = {
  placeholder?: {
    value: string;
    text: string;
  };
};

const ModelSelector: React.FC<FormItemProps<any> & Props> = (props) => {
  const [data, setData] = useState<
    { label: string; options: { value: string; label: string }[] }[]
  >([]);

  useEffect(() => {
    const init = async () => {
      const query = qs.stringify({
        code: "utf-8",
        ownsOnly: false,
      });
      const data = await UIFetchService.get(
        `/api/v1/querying_guide/templates?${query}`
      );
      if (Array.isArray(data)) {
        setData(
          data.map((dir) => ({
            label: dir.directoryName,
            options: Array.isArray(dir.templates)
              ? dir.templates.map((tem) => ({
                  label: tem.name,
                  value: tem.id + "",
                }))
              : [],
          }))
        );
      }
    };
    init();
  }, []);

  return (
    <Form.Item {...props}>
      <Select
        showSearch
        placeholder="搜索天机模板"
        style={{ width: 200 }}
        defaultActiveFirstOption={false}
        showArrow={true}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        notFoundContent={null}
        options={data}
      >
        {/* {options} */}
      </Select>
    </Form.Item>
  );
};

export default ModelSelector;
